<div class="body-container">
  <div class="content_header">
    <div class="header_actions">
      @if (accesComplet()) {
        <button
          type="button"
          appButton
          variant="outline"
          icon="download"
          [disabled]="!environnementSelectionne()"
          (click)="ouvrirImport()"
        >
          Importer depuis le legacy
        </button>
        <button
          type="button"
          appButton
          variant="primary"
          icon="plus"
          class="btn-header"
          [disabled]="!environnementSelectionne()"
          (click)="ouvrirCreation()"
        >
          Nouveau client
        </button>
      }
    </div>
  </div>

  <!-- Bande repliée en tête d'écran : la dernière modification est la première chose à voir
       quand on cherche à relier un incident client à un changement récent -->
  <app-historique-resume class="body-sub-container bande_historique"></app-historique-resume>

  <div class="body-sub-container">
    <div class="client_container">
      <h4>Sélectionnez un client</h4>

      <!-- `app-select` porte sa propre recherche et son effacement : le champ de
           saisie libre, le bouton « clear » et le chevron du montage Material
           disparaissent au profit d'un seul composant. -->
      <div class="ligne_filtres">
        <!-- Pas d'effacement ici : l'environnement est un contexte obligatoire.
             `choisirEnvironnement` ignore d'ailleurs une selection vide, la croix
             serait donc restee sans effet.
             Desactive quand ce deploiement n'a acces qu'a un seul environnement : il est
             deja selectionne (cf. ListeClientsService), et le champ reste visible pour
             montrer sur quel environnement on ecrit. -->
        <app-form-field label="Environnement" class="filter_element">
          <app-select
            label="Sélectionner un environnement"
            trigger="field"
            selectionMode="single"
            [fullWidth]="true"
            [disabled]="optionsEnvironnements().length <= 1"
            [options]="optionsEnvironnements()"
            [selected]="environnementsSelectionnes()"
            (selectionChange)="choisirEnvironnement($event)"
          />
        </app-form-field>

        <app-form-field label="Clients" class="filter_element">
          <app-select
            label="Sélectionner un client"
            trigger="field"
            selectionMode="single"
            [fullWidth]="true"
            [clearable]="true"
            [disabled]="!environnementSelectionne()"
            [options]="optionsClients()"
            [selected]="clientsSelectionnes()"
            (selectionChange)="choisirClient($event)"
          />
        </app-form-field>
      </div>

      @if (chargementEnCours()) {
        <div class="spinner-container">
          <app-spinner size="lg" ariaLabel="Chargement des clients" />
        </div>
      }
    </div>
  </div>

  <!-- Container séparé : sera conditionné par les droits de l'utilisateur -->
  @if (tenantSelectionne()) {
    <app-informations-client class="body-sub-container"></app-informations-client>
  }

  <!-- Paramétrage des connexions aux API partenaires pour le client sélectionné :
       Tech et Admin uniquement -->
  @if (tenantSelectionne() && accesComplet()) {
    <app-connect class="body-sub-container"></app-connect>
  }

  <!-- Panneau coulissant de l'historique, même gabarit que le détail d'un évènement dans
       Redditions : la consultation est ponctuelle, elle passe par-dessus l'écran plutôt que
       de comprimer le formulaire client. Fermeture au clic sur le fond -->
  <!-- Panneau lateral : `app-drawer` du design system remplace le dispositif
       maison (voile + conteneur coulissant). Il porte son propre voile, son
       animation, la fermeture au clic exterieur et a Echap, et le focus. -->
  @if (historiqueOuvert()) {
    <app-drawer ariaLabel="Historique du client" widthClass="w-[60vw]" (closed)="fermerHistorique()">
      @defer (when historiqueOuvert()) {
        @if (historiqueOuvert()) {
          <app-historique-client></app-historique-client>
        }
      }
    </app-drawer>
  }
</div>
